import PrettyDate from '@/components/PrettyDate';
import { MailThread } from '@/typings/models/Email';
import { F } from '@/utils/intl';
import { PaperClipOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import classNames from 'classnames';
import styles from './index.less';

const { Text } = Typography;

export interface MailThreadItemProps {
  thread: MailThread;
  onClick: () => void;
}

/** Outlook thread teaser in the lead summary card — same item chrome as the
 *  other project-detail cards (grey tile, accent border, hover lift). */
export default function MailThreadItem({
  thread,
  onClick,
}: MailThreadItemProps) {
  return (
    <div
      onClick={onClick}
      className={classNames(
        styles.projectDetailItemContainer,
        styles.mailItemContainer,
        styles.projectDetailItemContainerClickable,
      )}
    >
      <div className={styles.projectDetailItemContent}>
        <div className={styles.projectDetailItemHeader}>
          <Text ellipsis className={styles.mailSubject}>
            {thread.subject || (
              <F id="common.no_subject" defaultMessage="(No Subject)" />
            )}
          </Text>
          {thread.has_attachments && (
            <PaperClipOutlined className={styles.mailClip} />
          )}
          {thread.last_message_at && (
            <span className={styles.mailDate}>
              <PrettyDate date={thread.last_message_at} />
            </span>
          )}
        </div>
        <div className={styles.projectDetailItemBody}>
          <Text type="secondary" ellipsis className={styles.mailPreview}>
            {thread.last_message_preview}
          </Text>
        </div>
      </div>
    </div>
  );
}
